import React from 'react';

// NOTE: Stripe integration
// import StripeButton from '../stripeButton';

// const PayButton = (props) => <StripeButton {...props} />;

// NOTE: beanie integration
import BeanieButton from '../beanieButton';

const PayButton = (props) => <BeanieButton {...props} />;

export default PayButton;
